import type { ReactNode } from 'react';

/**
 * The persistent bottom tab bar. Australian golfers live in MiScore, and MiScore
 * puts Home / Scoring / Map / Settings across the bottom — a golfer flicks Map
 * <-> Score once a hole without thinking. GoCaddy mirrors that muscle memory:
 * Map, Score, Courses, Setup, always one tap away, so nobody has to learn a new
 * gesture on a buggy screen in the sun.
 */
export type NavTab = 'map' | 'score' | 'courses' | 'setup';

const I = {
  map: (
    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M12 21s-7-6.2-7-11a7 7 0 1 1 14 0c0 4.8-7 11-7 11z" />
      <circle cx="12" cy="10" r="2.5" />
    </svg>
  ),
  score: (
    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M6 3v18" /><path d="M6 4h11l-2 3 2 3H6" />
    </svg>
  ),
  courses: (
    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="11" cy="11" r="7" /><path d="M21 21l-4.3-4.3" />
    </svg>
  ),
  setup: (
    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="3" />
      <path d="M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9l2.1 2.1M17 17l2.1 2.1M4.9 19.1L7 17M17 7l2.1-2.1" />
    </svg>
  ),
};

const TABS: { key: NavTab; label: string; icon: ReactNode }[] = [
  { key: 'map', label: 'Map', icon: I.map },
  { key: 'score', label: 'Score', icon: I.score },
  { key: 'courses', label: 'Courses', icon: I.courses },
  { key: 'setup', label: 'Setup', icon: I.setup },
];

export default function BottomNav({
  active,
  onSelect,
}: {
  active: string;
  onSelect: (t: NavTab) => void;
}) {
  return (
    <nav className="bottom-nav" aria-label="Main">
      {TABS.map((t) => (
        <button
          key={t.key}
          className={`bn-item ${active === t.key ? 'on' : ''}`}
          onClick={() => onSelect(t.key)}
          aria-current={active === t.key ? 'page' : undefined}
        >
          <span className="bn-icon">{t.icon}</span>
          <span className="bn-label">{t.label}</span>
        </button>
      ))}
    </nav>
  );
}
